/* Text format buttons */
export const CANVAS_BLOCK_FORMAT = 'canvasblock';
export const CANVAS_FONT_FAMILY = 'canvasfontselect';
export const CANVAS_FONT_SIZE = 'canvasfontsizeselect';
export const CANVAS_BOLD = 'canvasbold';
export const CANVAS_ITALIC = 'canvasitalic';
export const CANVAS_UNDERLINE = 'canvasunderline';
export const CANVAS_TEXT_COLOR = 'canvasforecolor';
export const CANVAS_BACKGROUND_COLOR = 'canvasbackcolor';
export const CANVAS_ALIGNMENT = 'canvasalignment';
export const CANVAS_BULLETED_LIST = 'canvasbullist';
export const CANVAS_BULLETED_LIST_BUTTON = 'canvasbullistbutton';
export const CANVAS_NUMBERED_LIST = 'canvasnumlist';
export const CANVAS_NUMBERED_LIST_BUTTON = 'canvasnumlistbutton';
export const CANVAS_LINEHEIGHT = 'canvaslineheight';
export const CANVAS_OUTDENT = 'canvasoutdent';
export const CANVAS_INDENT = 'canvasindent';
export const CANVAS_REMOVE_FORMAT = 'canvasremoveformat';
export const CANVAS_STRIKETHROUGH = 'canvasstrikethrough';
export const CANVAS_SUPERSCRIPT = 'canvassuperscript';
export const CANVAS_SUBSCRIPT = 'canvassubscript';
export const CANVAS_CODE_FORMAT = 'canvascodeformat';

/* Insert buttons */
export const CANVAS_LINK = 'canvaslink';
export const CANVAS_IMAGE = 'canvasimage';
export const CANVAS_EMOJI = 'canvasemoji';
export const CANVAS_SNIPPET = 'canvassnippet';
export const CANVAS_PERSONALIZE = 'canvaspersonalize';
export const CANVAS_RSS_TOKEN = 'canvasrsstokens';
export const CANVAS_CALLOUT = 'canvascallout';
export const CANVAS_CTA = 'canvascta';
export const CANVAS_EMBED = 'canvasembed';
export const CANVAS_VIDEO = 'canvasvideo';
export const CANVAS_TABLE = 'canvastable';
export const CANVAS_CHARMAP = 'canvascharmap';
export const CANVAS_CHARMAP_BUTTON = 'canvascharmapbutton';
export const CANVAS_ICON = 'canvasicon';
export const CANVAS_ANCHOR = 'canvasanchor';
export const CANVAS_READ_MORE = 'canvasmore';
export const CANVAS_HR = 'canvashr';
export const CANVAS_NONBREAKING_SPACE = 'canvasnonbreaking';
export const CANVAS_CONTENT_GENERATION = 'canvascontentgeneration';
export const CANVAS_COPILOT_COLLABORATION = 'canvascopilotcollabortation';
export const CANVAS_AI_DYNAMIC_TOKENS = 'canvasdynamictext';

/* Advanced buttons */
export const CANVAS_SOURCE_CODE = 'canvassourcecode';
export const CANVAS_SOURCE_CODE_BUTTON = 'canvassourcecodebutton';
export const CANVAS_VISUAL_BLOCKS = 'canvasvisualblocks';

/* Context toolbar style buttons */
export const CANVAS_ALIGNMENT_INLINE = 'canvasalignmentinline';
export const CANVAS_ALIGNMENT_LEFT = 'canvasalignmentleft';
export const CANVAS_ALIGNMENT_CENTER = 'canvasalignmentcenter';
export const CANVAS_ALIGNMENT_RIGHT = 'canvasalignmentright';
export const CANVAS_ALIGNMENT_FULL_WIDTH = 'canvasalignmentfullwidth';
export const CANVAS_ALIGNMENT_DROPDOWN = 'canvasalignmentdropdown';
export const CANVAS_VERTICAL_ALIGNMENT_BOTTOM = 'canvasverticalalignmentbottom';
export const CANVAS_VERTICAL_ALIGNMENT_MIDDLE = 'canvasverticalalignmentmiddle';
export const CANVAS_VERTICAL_ALIGNMENT_TOP = 'canvasverticalalignmenttop';
export const CANVAS_VERTICAL_ALIGNMENT_DROPDOWN = 'canvasverticalalignmentdropdown';
export const CANVAS_DIMENSIONS = 'canvasdimensions';
export const CANVAS_MARGINS = 'canvasmargins';
export const CANVAS_FILL_COLOR = 'canvasfillcolor';
export const CANVAS_ROTATION = 'canvasrotation';
export const CANVAS_ICON_TYPE = 'canvasicontype';
export const CANVAS_BORDER_COLOR = 'canvasbordercolor';
export const CANVAS_TABLE_STYLES = 'canvastablestyles';
export const CANVAS_TABLE_CELL_STYLES = 'canvastablecellstyles';

/**
 * Mapping of toolbar options to their respective control(s). The
 * keys represent the strings used in the module schemas that build
 * the [enabledFeatures] config option.
 *
 * Some options map to more than one control.
 * The following options correspond to groups of controls:
 *
 * `colors`            -> text_color + background_color
 * `fonts`             -> font_family + font_size
 * `indents`           -> outdent + indent
 * `lists`             -> bulleted_list + numbered_list
 * `standard_emphasis` -> bold + italic + underline
 * `advanced_emphasis` -> strikethrough + superscript + subscript + code_format
 * `glyphs`            -> emoji + charmap + icon
 *
 * ...
 *
 * Omitted controls:
 *   - CANVAS_REMOVE_FORMAT:     (This is INCLUDED BY DEFAULT to all toolbars)
 *   - CANVAS_RSS_TOKEN:         (email specific)
 *   - CANVAS_CALLOUT:           (kb specific (for now))
 *   - CANVAS_READ_MORE:         (blog specific)
 */
export const ToolbarControlOptionsMap = {
  /* Text formats */
  block: [CANVAS_BLOCK_FORMAT],
  font_family: [CANVAS_FONT_FAMILY],
  font_size: [CANVAS_FONT_SIZE],
  bold: [CANVAS_BOLD],
  italic: [CANVAS_ITALIC],
  underline: [CANVAS_UNDERLINE],
  text_color: [CANVAS_TEXT_COLOR],
  background_color: [CANVAS_BACKGROUND_COLOR],
  alignment: [CANVAS_ALIGNMENT],
  bulleted_list: [CANVAS_BULLETED_LIST],
  numbered_list: [CANVAS_NUMBERED_LIST],
  lineheight: [CANVAS_LINEHEIGHT],
  outdent: [CANVAS_OUTDENT],
  indent: [CANVAS_INDENT],
  strikethrough: [CANVAS_STRIKETHROUGH],
  superscript: [CANVAS_SUPERSCRIPT],
  subscript: [CANVAS_SUBSCRIPT],
  code_format: [CANVAS_CODE_FORMAT],
  /* Inserts */
  link: [CANVAS_LINK],
  image: [CANVAS_IMAGE],
  emoji: [CANVAS_EMOJI],
  snippet: [CANVAS_SNIPPET],
  personalize: [CANVAS_PERSONALIZE],
  cta: [CANVAS_CTA],
  embed: [CANVAS_EMBED],
  video: [CANVAS_VIDEO],
  table: [CANVAS_TABLE],
  charmap: [CANVAS_CHARMAP],
  icon: [CANVAS_ICON],
  anchor: [CANVAS_ANCHOR],
  hr: [CANVAS_HR],
  nonbreaking_space: [CANVAS_NONBREAKING_SPACE],
  content_generation: [CANVAS_CONTENT_GENERATION],
  copilot_collaboration: [CANVAS_COPILOT_COLLABORATION],
  ai_dynamic_tokens: [CANVAS_AI_DYNAMIC_TOKENS],
  /* Advanced */
  source_code: [CANVAS_SOURCE_CODE],
  visual_blocks: [CANVAS_VISUAL_BLOCKS],
  /* Groups of controls */
  colors: [CANVAS_TEXT_COLOR, CANVAS_BACKGROUND_COLOR],
  fonts: [CANVAS_FONT_FAMILY, CANVAS_FONT_SIZE],
  indents: [CANVAS_OUTDENT, CANVAS_INDENT],
  lists: [CANVAS_BULLETED_LIST, CANVAS_NUMBERED_LIST],
  standard_emphasis: [CANVAS_BOLD, CANVAS_ITALIC, CANVAS_UNDERLINE],
  advanced_emphasis: [CANVAS_STRIKETHROUGH, CANVAS_SUPERSCRIPT, CANVAS_SUBSCRIPT, CANVAS_CODE_FORMAT],
  glyphs: [CANVAS_EMOJI, CANVAS_CHARMAP, CANVAS_ICON]
};

/*
 * These are externally-exposed toolbar control options that the developer
 * can pass down in the [enabledFeatures] prop of the config. This array
 * will be used as a filter when building the toolbar configuration.
 * Unrecognized toolbar options will be ignored, and if the [enabledFeatures]
 * prop is empty or undefined no filtering will be performed and the default
 * toolbar defined for that config will be used.
 *
 * Example usage:
 *
 * getConfig({
 *   appName: 'Example App',
 *   enabledFeatures: ['block', 'standard_emphasis', 'colors', 'link', 'source_code'],
 *   ...rest,
 * });
 */
const _ToolbarControlOptions = Object.keys(ToolbarControlOptionsMap).reduce((acc, key) => {
  acc[key] = key;
  return acc;
}, {});
export const ToolbarControlOptions = _ToolbarControlOptions;